import * as actions from '../../redux/actions';
import * as homeActions from '../../../home/redux/apiCall';

import React, { useEffect, useRef, useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import { AppData } from '../../../../services';
import GoogleMapReact from 'google-map-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const AnyReactComponent = ({ img }) => (
	<div>
		<img
			style={{
				display: 'inline-block',
				width: '20px',
			}}
			src={img}
			alt=""
		/>
	</div>
);

const TarapacaOfficeSection = props => {
	const [selectedOffice, setSelectedOffice] = useState({});
	const [offices, setOffices] = useState([]);
	const [showAll, setShowAll] = useState(false);
	const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
	const [scrolEnd, setscrolEnd] = useState(false); // For detecting end of scrolling
	const scrl = useRef({});

	const [latLong, setLatLong] = useState({
		lat: '-33.456130',
		long: '-70.688390',
	});

	// console.log('props================================', props);
	// useEffect(() => {
	//   //Check width of the scollings
	//   if (
	//     scrl.current &&
	//     scrl.current.scrollWidth &&
	//     scrl.current.offsetWidth &&
	//     scrl.current.scrollWidth === scrl.current.offsetWidth
	//   ) {
	//     setscrolEnd(true);
	//   } else {
	//     setscrolEnd(false);
	//   }
	//   return () => {};
	// }, [scrl.current && scrl.current.scrollWidth, scrl.current && scrl.current.offsetWidth]);

	useEffect(() => {
		props.actions.apiCall({
			type: 'home',
			url: ApiUrls.officeDetails(),
			// url: AppData.BASE_URL + 'api/office_details',
			callback: res => onResponse(res),
		});
	}, []);

	const onResponse = res => {
		console.log('onResponse', res);

		if (res && res.data && res.data.offices && res.data.offices.length > 0) {
			const data = res.data.offices.map((val, i) => {
				val.active = i === 0 ? true : false;
				return val;
			});
			setOffices(data);
			setSelectedOffice(data && data[0]);
			setLatLong({
				lat:
					data &&
					data[0].subOffices &&
					data[0].subOffices.length > 0 &&
					data[0].subOffices[0].lat &&
					data[0].subOffices[0].lat,
				long:
					data[0] &&
					data[0].subOffices &&
					data[0].subOffices.length > 0 &&
					data[0].subOffices[0].long &&
					data[0].subOffices[0].long,
			});
		}
	};

	const onSelect = item => {
		const data = offices.map((val, i) => {
			val.active = val.title === item.title ? true : false;
			return val;
		});
		setOffices(data);
		setSelectedOffice(item);
		setLatLong({
			lat:
				item &&
				item.subOffices &&
				item.subOffices.length > 0 &&
				item.subOffices[0].lat &&
				item.subOffices[0].lat,
			long:
				item &&
				item.subOffices &&
				item.subOffices.length > 0 &&
				item.subOffices[0].long &&
				item.subOffices[0].long,
		});
	};

	const slide = (shift, left) => {
		setscrollX(scrollX + shift); // Updates the latest scrolled postion

		//For checking if the scroll has ended
		if (
			Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <= scrl.current.offsetWidth
		) {
			if (left) {
				setscrolEnd(false);
				scrl.current.scrollLeft += shift;
			} else {
				setscrolEnd(true);
			}
		} else {
			scrl.current.scrollLeft += shift;
			setscrolEnd(false);
		}

		console.log(scrl);
	};

	console.log(scrollX);
	const scrollCheck = () => {
		setscrollX(scrl.current.scrollLeft);
		// if (
		//   Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <= scrl.current.offsetWidth
		// ) {
		//   setscrolEnd(true);
		// } else {
		//   setscrolEnd(false);
		// }
	};

	console.log('scroll', scrl.current.scrollLeft);

	return (
		<div className="themes-theme-two-office-section new-container">
			<div
				className="d-flex"
				style={{
					backgroundColor:
						props.operator &&
						props.operator.color_codes &&
						props.operator.color_codes.secondary_color &&
						props.operator.color_codes.secondary_color,
					color:
						props.operator &&
						props.operator.color_codes &&
						props.operator.color_codes.secondary_text_color &&
						props.operator.color_codes.secondary_text_color,
				}}
			>
				{scrollX !== 0 ? (
					<span onClick={() => slide(-200, true)} className="arrow pointer ">
						<img src="/assets/jetsur/Arrow.svg" className="left" alt="" />
					</span>
				) : null}

				<div
					ref={scrl}
					className="office-list"
					onScroll={scrollCheck}
					style={{
						justifyContent:
							(props.operator && props.operator.operator_name === 'combarbala') ||
								props.operator.operator_name === 'expresosantacruz'
								? 'flex-start'
								: '',
					}}
				>
					{offices.map((item, index) => {
						return (
							<div
								className="office-item less-bold-text"
								key={index}
								style={
									item.active
										? {
											color:
												props.operator &&
												props.operator.color_codes &&
												props.operator.color_codes.button_color &&
												props.operator.color_codes.button_color,
										}
										: {}
								}
								onClick={() => onSelect(item)}
							>
								<span className="office-item-name">{item.title}</span>
							</div>
						);
					})}
				</div>

				{offices && offices.length > 6 && !scrolEnd ? (
					<span onClick={() => slide(+200)} className="arrow  pointer">
						<img src="/assets/jetsur/Arrow.svg" className="right" alt="" />
					</span>
				) : null}
			</div>


			{props.operator && props.operator.operator_name === "barriaghisoni" ? (
				<React.Fragment>
					<div
						className=" bottom-section less-padding"
						style={{
							backgroundColor:
								props.operator && props.operator.operator_name === 'cormarbus'
									? props.operator.color_codes &&
									props.operator.color_codes.primary_color &&
									props.operator.color_codes.primary_color
									: props.operator.color_codes &&
									props.operator.color_codes.button_color &&
									props.operator.color_codes.button_color,
						}}
					>


						{selectedOffice &&
							selectedOffice.subOffices &&
							selectedOffice.subOffices.length > 0 &&
							selectedOffice.subOffices[0].lat &&
							selectedOffice.subOffices[0].long ? (
							<div className="map">
								<GoogleMapReact
									bootstrapURLKeys={{ key: AppData.MAP_API_KEY }}
									center={{
										lat: parseFloat(selectedOffice.subOffices[0].lat),
										lng: parseFloat(selectedOffice.subOffices[0].long),
									}}
									defaultZoom={11}
								>
									<AnyReactComponent
										lat={parseFloat(selectedOffice.subOffices[0].lat)}
										lng={parseFloat(selectedOffice.subOffices[0].long)}
										img="/assets/bahia/General/pin.png"
									/>
								</GoogleMapReact>
							</div>

						) : null}
						<SelectedOffice operator={props.operator} selectedOffice={selectedOffice} />
					</div>
				</React.Fragment>
			) : (

				<React.Fragment>
					<div
						className="bottom-section"
						style={{
							backgroundColor:
								props.operator && props.operator.operator_name === 'cormarbus'
									? props.operator.color_codes &&
									props.operator.color_codes.primary_color &&
									props.operator.color_codes.primary_color
									: props.operator.color_codes &&
									props.operator.color_codes.button_color &&
									props.operator.color_codes.button_color,
						}}
					>
						{selectedOffice &&
							selectedOffice.subOffices &&
							selectedOffice.subOffices.length > 0 &&
							selectedOffice.subOffices[0].lat &&
							selectedOffice.subOffices[0].long ? (
							<div className="map">
								<GoogleMapReact
									bootstrapURLKeys={{ key: AppData.MAP_API_KEY }}
									center={{
										lat: parseFloat(selectedOffice.subOffices[0].lat),
										lng: parseFloat(selectedOffice.subOffices[0].long),
									}}
									defaultZoom={11}
								>
									<AnyReactComponent
										lat={parseFloat(selectedOffice.subOffices[0].lat)}
										lng={parseFloat(selectedOffice.subOffices[0].long)}
										img="/assets/bahia/General/pin.png"
									/>
								</GoogleMapReact>
							</div>
						) : null}
						<SelectedOffice operator={props.operator} selectedOffice={selectedOffice} />
					</div>
				</React.Fragment>
			)}
			{/* {selectedOffice &&
					selectedOffice.subOffices &&
					selectedOffice.subOffices.length > 0 &&
					selectedOffice.subOffices[0].lat &&
					selectedOffice.subOffices[0].long ? (

					<div className="map">
						<GoogleMapReact
							bootstrapURLKeys={{ key: AppData.MAP_API_KEY }}
							center={{
								lat: parseFloat(latLong.lat),
								lng: parseFloat(latLong.long),
							}}
							defaultZoom={11}
						>
							<AnyReactComponent
								lat={parseFloat(latLong.lat)}
								lng={parseFloat(latLong.long)}
								img="/assets/bahia/General/pin.png"
							/>
						</GoogleMapReact>
					</div>
				) : null} */}

			{/* <SelectedOffice operator={props.operator} selectedOffice={selectedOffice} /> */}

		</div>
	);
};


const SelectedOffice = ({ selectedOffice, operator }) => {
	let phoneNumberOne = '';
	let phoneNumberTwo = '';

	if (operator && operator.operator_name === 'barriaghisoni') {
		const temp = operator.phone_number.split('/');
		phoneNumberOne = temp[0];
		phoneNumberTwo = temp[1];
	}

	operator && operator.operator_name === 'cormarbus';
	return (
		<div
			className="selected"
			style={{
				color:
					operator && operator.operator_name === 'cormarbus' || 'santamaria' || "biaggini"
						? operator.color_codes &&
						operator.color_codes.tertiary_text_color &&
						operator.color_codes.tertiary_text_color
						: '#fff',
				justifyContent: 'flex-start',
				paddingTop: operator && operator.operator_name === 'barriaghisoni' ? 100 : 20,
				paddingLeft: operator && operator.operator_name === 'barriaghisoni' ? 40 : 20,
			}}
		>
			{selectedOffice && selectedOffice.subOffices && selectedOffice.subOffices.length
				? selectedOffice.subOffices.map((value, index) => {
					return (
						<div key={index} className="selected-office  less-bold-text" style={{}}>
							<div className="terminal "
								style={{
									// color:
									//   operator && operator.color_codes && operator.color_codes.primary_color
									//     ? operator.color_codes.primary_color
									//     : '',
									color:
										operator && operator.operator_name === 'kennybus'
											? '##444687'
											: operator && operator.operator_name === 'tarapaca'
												? '#2f2f2f'
												: operator && operator.operator_name === 'cormarbus'
													? '#477ee6'
													: operator && operator.color_codes && operator.color_codes.primary_color
														? operator.color_codes.primary_color
														: '',
								}}
							>
								<img
									src={getIcons('pin', operator)}
									alt=""
									className="icon-size icon-left"
									style={{ marginLeft: '-5px', marginBottom: '2px' }}
								/>
								{value.terminal}
							</div>
							{value.phone ? (
								<div
									className="phone " //upper-case-text
									style={{
										marginTop: '8px',
										color: operator && operator.operator_name === 'barriaghisoni' ? '#e0e5f4' : operator.operator_name === 'tarapaca' ? '#2f2f2f' : '#fff',
										display: 'flex',
										alignItems: 'end',
									}}
								>
									<div
										style={{
											paddingLeft: 17,
										}}
									>
										Teléfono: &nbsp;{' '}
									</div>
									{operator && operator.operator_name === 'barriaghisoni' ? (
										<div>
											<span>{phoneNumberOne}</span> {' // '}
											<span className="d-inline-block">{phoneNumberTwo}</span>
										</div>
									) : (
										value.phone
									)}
								</div>
							) : null}
							{/* <div className="address">{value.address}</div> */}
						</div>
					);
				})
				: null}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(TarapacaOfficeSection);



// WEBPACK FOOTER //
// ./src/features/themes/Tarapaca/common/TarapacaOfficeSection.js